import React, { useState } from 'react';
import LomavisButtonToggle1 from '../../../generic/buttons/LomavisButtonToggle1';
import { useTranslate } from '@tolgee/react';
import { RIGHT_COLUMN_OPTIONS } from '../../../../redux/slices/LomavisPostApproval/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalStates } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';

const RightColumnToggle: React.FC = () => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState('config');
  const { t } = useTranslate();

  const {
    local_states: { selected_config_tab, right_column_options }
  } = useSelector((state: any) => state.lomavisPostApproval);

  return (
    <LomavisButtonToggle1
      buttonLeftFaIconClass="fa-duotone fa-solid fa-user-check"
      buttonLeftText={t('lomavisPostApproval.rightColumn.toggleApprovalUsers')}
      buttonLeftValue={RIGHT_COLUMN_OPTIONS.RIGHT_COLUMN_USERS}
      buttonRightFaIconClass="fa-duotone fa-solid fa-hourglass-half"
      buttonRightText={t('lomavisPostApproval.rightColumn.toggleProgress')}
      buttonRightValue={RIGHT_COLUMN_OPTIONS.RIGHT_COLUMN_PROGRESS}
      value={right_column_options}
      onChange={(value: string) => {
        dispatch(setLocalStates({ key: 'right_column_options', value }));
      }}
    />
  );
};

export default RightColumnToggle;
